/*
 * @Description: 日桌面养成图表接口
 * @Author: zcy
 * @Date: 2022-02-21 11:31:36
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-02-27 10:40:55
 */
import http from "../../../axios/index";

const service = {
  // 饲料现存量图表接口-养成
  getMdtFodderDataGroupByChart(params) {
    let {
      orgId,
      day,
    } = params;
    return http.post('/mdtFodderDataGroup/getMdtFodderDataGroupByChart', {
      orgId,
      day
    });
  },

  // 动保现存量图表接口-养成
  DynamicGetChatrs(params) {
    let {
      orgId,
      day,
    } = params;
    return http.post('/mdtDrugDataGroup/getMdtDrugDataGroupByChart', {
      orgId,
      day
    });
  },

  // 饲料日投喂图表接口-养成
  getPrivateChatCharts(params) {
    let {
      orgId,
      breedTypeClass,
      day,
    } = params;
    return http.post('/trFeedingDetailDay/getFeedingDailyGroupByChart', {
      orgId,
      breedTypeClass,
      day
    });
  },

  // 动保日投用数据接口
  getDynamicCharts(params) {
    let {
      orgId,
      breedTypeClass,
      day,
    } = params;
    return http.post('/trDrugBoxDaily/getFishUseMedicineGroupByChart', {
      orgId,
      breedTypeClass,
      day
    });
  },

  // 各区域各品种死鱼情况需要获取到养殖机构id再进行搜索
  ycChaartGetPeriodld(params){
    let {
      orgId,
      day,
      breedTypeClass
    } = params;
    return http.post('/mdtHarvestAnalysisOrg/getLastPeriodId', {
      orgId,
      day,
      breedTypeClass
    });
  },

  // 各区域各品种死鱼情况
  regionDeadFishCharts(params){
    let {
      orgId,
      day,
      firstDay
    } = params;
    return http.post('/loss/getDailyDeadSpeciesFishGroupChart', {
      orgId,
      day,
      firstDay
    });
  },

  // 日死鱼情况折线图接口
  getSundeadfishCharts(params){
    let {
      orgId,
      day,
    } = params;
    return http.post('/loss/getDailyDeadFishGroupChart', {
      orgId,
      day
    });
  },
  // 一造次各品种销售产值、收获产量、收获面积(养成)
  getForTargetValueByPieChart(params){
    let {
      orgId,
      day,
      breedTypeClass
    } = params;
    return http.post('/mdtHarvestAnalysisOrg/getForTargetValueByPieChart', {
      orgId,
      day,
      breedTypeClass
    });
  },
  // 一造次各品种收获塘口数
  getBreedNameChartForHarvestBoxNum(params){
    let {
      orgId,
      day,
      breedTypeClass
    } = params;
    return http.post('/mdtHarvestAnalysisOrg/getBreedNameChartForHarvestBoxNum', {
      orgId,
      day,
      breedTypeClass
    });
  },
   // 一造次各品种育苗天数与投入成本
   getMdtHarvestAnalysisOrgByChart(params){
    let {
      orgId,
      day,
      breedTypeClass
    } = params;
    return http.post('/mdtHarvestAnalysisOrg/getMdtHarvestAnalysisOrgByChart', {
      orgId,
      day,
      breedTypeClass
    });
  },

  // 一造次各品种投卵情况
  searchMdtHarvestAnalysisOrgByPutNumList(params){
    let {
      orgId,
      day,
      breedTypeClass
    } = params;
    return http.post('/mdtHarvestAnalysisOrg/searchMdtHarvestAnalysisOrgByPutNumList', {
      orgId,
      day,
      breedTypeClass
    });
  },

  // 一造次饲料使用情况
  searchMdtHarvestAnalysisOrgByUseFodderList(params){
    let {
      orgId,
      day,
      breedTypeClass
    } = params;
    return http.post('/mdtHarvestAnalysisOrg/searchMdtHarvestAnalysisOrgByUseFodderList', {
      orgId,
      day,
      breedTypeClass
    });
  },

  // 一造次各品种销售产值、收获产量、收获面积（养成）
  getOrgForTargetValue(params){
    let {
      orgId,
      day,
      breedTypeClass
    } = params;
    return http.post('/mdtHarvestAnalysisOrg/searchMdtHarvestAnalysisOrgForTargetValue', {
      orgId,
      day,
      breedTypeClass
    });
  },
}



export default service
